import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import FlagIcon from 'vue-flag-icon'
import axios from 'axios'
import VueTelInput from 'vue-tel-input'
import UUID from 'vue-uuid'
import Push from 'push.js'
import * as firebase from "firebase/app"
import "firebase/messaging"
import VueNativeSock from 'vue-native-websocket'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueExcelXlsx from 'vue-excel-xlsx'


const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}

if (firebase.messaging.isSupported()) {
  console.log('Push Notifications Supported')
  const messaging = firebase.messaging()

  messaging.usePublicVapidKey("BOZ6AWJsi3J5Oj1S9PV1IQ0oKI-YpdphV3NZE1tKsKqeRzE-tajTpAk-l2FI0EO5akEBYc1FuIO8JY-IEB5gZWI")

  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      console.log('Notification permission granted.')
      new Notification('Gracias por aceptar las notificaciones')
      // TODO(developer): Retrieve an Instance ID token for use with FCM.
      // ...
    } else {
      console.log('Unable to get permission to notify.')
    }
  })
  messaging.requestPermission().then(function () {
    console.log('Have Permission')
    return messaging.getToken()
  }).then((token) => {
    console.log('token', token)
  }).catch((err) => {
    console.log('Have not permission', err)
  })
  console.log('mensaje', messaging)
  // Handle incoming messages. Called when:
  // - a message is received while the app has focus
  // - the user clicks on an app notification created by a service worker
  //   `messaging.setBackgroundMessageHandler` handler.
  messaging.onMessage(function (payload) {
    console.log('Message received. ', payload.notification)
    Push.create(payload.notification.title, {
      body: payload.notification.body,
      icon: require('./assets/logo_escuela.png'),
      onClick: function () {
        window.focus()
        this.close()
      }
    })
  })
} else {
  console.log('Push Notifications Not Supported')
}
Vue.config.productionTip = false

export const HTTP = axios.create({
  baseURL: 'https://escuela-service.intrare.app/'
  // baseURL: 'http://127.0.0.1:8000/'
})

Vue.use(VueTelInput)
Vue.use(FlagIcon)
Vue.use(UUID)
Vue.use(VueExcelXlsx)
Vue.use(VueNativeSock, 'ws://127.0.0.1:8000', {
  connectManually: true,
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionAttempts: 0, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
})
Vue.use(Snotify, options)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  axios,
  render: h => h(App)
}).$mount('#app')
